var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapeTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6054 25.7599H8.34734C5.3941 25.7599 3 23.3659 3 20.4126V5.15454C3 4.07466 3.87544 3.19922 4.95532 3.19922H20.2133C23.1666 3.19922 25.5607 5.59332 25.5607 8.54656V23.8046C25.5607 24.8845 24.6852 25.7599 23.6054 25.7599Z",
    fill: "#DC7296"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6234 36.7972H29.7023C27.2898 36.7972 25.334 34.8414 25.334 32.4288V26.5077C25.334 25.9684 25.7711 25.5312 26.3104 25.5312H32.2315C34.6442 25.5312 36.5999 27.487 36.5999 29.8996V35.8208C36.5999 36.3601 36.1627 36.7972 35.6234 36.7972Z",
    fill: "#FBCDD7",
    fillOpacity: 0.32
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9911 31.7282H18.7327C16.011 31.7282 13.8047 29.5219 13.8047 26.8002V15.5418C13.8047 14.6935 14.4924 14.0059 15.3407 14.0059H26.599C29.3207 14.0059 31.527 16.2122 31.527 18.9339V30.1922C31.527 31.0405 30.8394 31.7282 29.9911 31.7282Z",
    fill: "#FBCDD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeTwo);
export default __webpack_public_path__ + "static/media/shape-two.3c959bf9aed9b364af5611808dd4bcd0.svg";
export { ForwardRef as ReactComponent };